import PropTypes from 'prop-types';
import React from 'react';
import styles from '../InfoDialog.scss';
import CSSModules from "react-css-modules";
import SunbitDialog from "../../../components/common/material/Dialog";
import RaisedButton from "../../../components/common/material/RaisedButton";
import Button from "../../../components/common/material/Button";
import {FormattedMessage} from "react-intl";

@CSSModules(styles, {allowMultiple: true})
class SalaryOutOfRangeDialog extends React.Component {

  constructor(props) {
    super(props)

  }

  render() {
    return <SunbitDialog theme={{dialog:styles.dialogContainer ,body : styles.dialogBody}} active={this.props.isOpen}>
        <div styleName={'dialogCloseIcon'}>
          <div styleName={'closeModalIcon'} onClick={this.props.handleClose} />
        </div>
      <div styleName={'modalHeader'}>
        <div data-at={'salaryOutOfRangeModalTitle'} styleName={'modalTitle'}>
        <FormattedMessage id={'atpUpdate.salaryOutOfRange.dialog.title'}/>
        </div>
      </div>
      <div data-at={'salaryOutOfRangeModalContent'} styleName={'modalContent dialogContent'}>
        <FormattedMessage id={'atpUpdate.salaryOutOfRange.dialog.content'}/>
      </div>
        <div styleName={'actionGroup'}>
          <Button  flat={true} styleName={'actionBtn secondaryBtn'} data-at={'salaryOutOfRangeModalUpdateBtn'}  onClick={this.props.handleClose} >
            <FormattedMessage id={'atpUpdate.salaryOutOfRange.dialog.updateAction'}/>
          </Button>
          <RaisedButton  styleName={'actionBtn'} data-at={'salaryOutOfRangeModalContinueBtn'} primary={true} onClick={this.props.handleSubmit}>
            <FormattedMessage id={'atpUpdate.salaryOutOfRange.dialog.continueAction'}/>
          </RaisedButton>
        </div>
    </SunbitDialog>
  }

}

SalaryOutOfRangeDialog.propTypes = {
  handleClose : PropTypes.func,
  handleSubmit : PropTypes.func,
  isOpen:PropTypes.bool
};

export default SalaryOutOfRangeDialog;



// WEBPACK FOOTER //
// ./src/card/CardDialogs/SalaryOutOfRangeDialog/SalaryOutOfRangeDialog.js